import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from '../Icon/Icon'
import './HardwareCard.scss'

export const HardwareCard = ({ locale, url, image: { src, alt }, title }) => {
  return (
    <div className="hardware-card">
      <Link className="hardware-card__link" to={`/${locale}/${url}`}>
        <img alt={alt} className="hardware-card__image" src={`${src}`} />
        <div className={'hardware-card__title'}>
          <span className="hardware-card-title__text">{title}</span>
          <span className="hardware-card-title__image">
            <Icon type="chevron-right" />
          </span>
        </div>
      </Link>
    </div>
  )
}

HardwareCard.propTypes = {
  locale: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

export default HardwareCard
